// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { requisitionsProductListLineStyles } from "@conklin/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};
requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};
requisitionsProductListLineStyles.subtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};
requisitionsProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

requisitionsProductListLineStyles.productImageStyles = {
    ...mergeWithCss(cartLineSharedStyles.productImage, {
        linkWrappingImage: {
            css: css`
                width: 120px;
                height: 120px;
            `,
        },
    }),
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    mergeCss: true,
    css: css`
        margin-top: 10px;
    `,
};

requisitionsProductListLineStyles.LinesHeader = {
    wrapper: {
        css: css`
            && {
                grid-template-columns: 145px minmax(45px, 1fr) minmax(0, 188px) minmax(0, 108px) minmax(0, 148px);
            }
        `,
    },
};
requisitionsProductListLineStyles.GridContainer = {
    notes: {
        css: css`
            grid-column: 1 / 6;
            grid-row: 5 / 6;
            margin-top: 10px;
        `,
    },
    container: {
        css: css`
            && {
                grid-template-columns: 145px minmax(45px, 1fr) minmax(0, 188px) minmax(0, 108px) minmax(0, 148px);
                position: relative;
                padding: 8px;
                margin-bottom: 12px;
                &:last-child {
                    border-bottom: 1px solid ${color("common.border")};
                }
            }
        `,
    },
    image: {
        css: css`
            margin-left: 25px;
        `,
    },
    qty: {
        css: css`
            ${xScreen("lte", "md")} {
                margin-left: 25px;
            }
        `,
    },
    inventory: {
        css: css`
            ${xScreen("lte", "md")} {
                margin-left: 25px;
                margin-bottom: 12px;
            }
        `,
    },
};

requisitionsProductListLineStyles.selectedCheckbox = {
    css: css`
        position: absolute;
        left: 12px;
        top: 12px;
        ${xScreen("lte", "md")} {
            left: 6px;
        }
    `,
};

requisitionsProductListLineStyles.productInfoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};
